import * as React from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { useRefValue } from "./useRefValue";

export const getBackUrl = (): string => window.history.state?.usr?.backUrl || null;

export const useBackNavigate = () => {
  const navigate = useNavigate();
  return React.useCallback((defaultTo: string) => {
    getBackUrl() ? navigate(-1) : navigate(defaultTo);
  }, []);
}

export const useOnClickBack = () => {
  const backUrl = useRefValue(useBackUrl());
  const navigate = useNavigate();
  return React.useCallback((e: React.MouseEvent) => {
    if (backUrl.current) {
      e.preventDefault();
      navigate(-1);
    }
  }, []);
}

export const useBackUrl = () => {
  const location = useLocation();
  return (location.state as any)?.backUrl;
}